module.exports = __webpack_public_path__ + "img/icon1.16ba9205.png";